import { View, ViewProps } from 'react-native';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { useFormContext } from 'react-hook-form';

import { FormRadioGroup, RadioOptionValueType } from '../Radio';
import { FormRangeDatepicker, RangeDatepickerProps } from '../DatePicker';
import { withTranslation } from '../../locales/hoc';

type Props = Pick<ViewProps, 'style'> & {
	radioGroupProps: {
		name: string;
		label: string;
	};
	rangeDatepickerProps: {
		name: string;
	} & RangeDatepickerProps;
} & (
		| {
				dayOptions: string[];
				radioOptions?: never;
		  }
		| {
				dayOptions?: never;
				radioOptions: { label: string; value: RadioOptionValueType }[];
		  }
	);

const getDefaultRadioOptions = (
	t: TFunction,
	dayOptions: string[],
): { label: string; value: RadioOptionValueType }[] =>
	dayOptions.map((days) => ({
		label: t('form-period-control.period.day', { count: Number(days) }),
		value: days,
	}));

const FormPeriodControlComponent = ({
	style,
	radioGroupProps,
	rangeDatepickerProps,
	dayOptions,
	radioOptions,
}: Props) => {
	const { t } = useTranslation();

	const options = radioOptions ? radioOptions : getDefaultRadioOptions(t, dayOptions);

	const formMethods = useFormContext();
	const watchPeriod = formMethods.watch(radioGroupProps.name);
	const optionsToDisplay: { label: string; value: RadioOptionValueType }[] = [
		...options,
		{ label: t('form-period-control.period.custom'), value: 'custom' },
	];

	return (
		<View style={style}>
			<FormRadioGroup
				{...radioGroupProps}
				options={optionsToDisplay}
				defaultValue={optionsToDisplay[0].value}
			/>
			{watchPeriod === 'custom' && <FormRangeDatepicker {...rangeDatepickerProps} />}
		</View>
	);
};

export const FormPeriodControl = withTranslation(FormPeriodControlComponent);
